// 多语言基础（纯数据，客户端/服务端均可 import）
// 语言 Cookie 切换、URL 不变；服务端组件用 lib/i18n/server.ts 的 getLocale() 读取
export type Locale = 'zh' | 'en'

export const LOCALES: Locale[] = ['zh', 'en']
export const DEFAULT_LOCALE: Locale = 'zh'
export const LOCALE_COOKIE = 'yygame_lang'

export function normalizeLocale(v: string | undefined | null): Locale {
    return v === 'en' ? 'en' : 'zh'
}

/** 按 locale 取字典：zh 直接返回，en 缺失时回退 zh */
export function pick<T>(dict: { zh: T; en: T }, locale: Locale): T {
    return locale === 'en' ? dict.en : dict.zh
}
